import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Card from 'react-bootstrap/Card';

export type UserDefaultCardProps = {
  title?: string;
  subtitle?: string;
  onClick?: React.MouseEventHandler;
};

const UserDefaultCard = ({
  title = 'Add new',
  subtitle = 'beneficiery',
  onClick
}: UserDefaultCardProps) => {
  return (
    <Card bsPrefix={'cnd-user-card'} onClick={onClick} className={'default d-flex flex-lg-column align-items-center'}>
      <div className={'cnd-user-card--image-wrapper d-flex justify-content-center align-items-center'}>
        <FontAwesomeIcon icon={light('plus')} />
      </div>
      <Card.Body className={'d-flex flex-lg-column justify-content-lg-center align-items-lg-center'}>
        <Card.Title>{title}</Card.Title>
        <Card.Subtitle>{subtitle}</Card.Subtitle>
      </Card.Body>
    </Card>
  );
};

export default UserDefaultCard;
